// extracted by mini-css-extract-plugin
export default {"session-status-title":"SessionStatusPanel_session-status-title__vyAGd","session-status-value":"SessionStatusPanel_session-status-value__Hc-gx"};